// @flow
import { Map, fromJS } from "immutable";
import moment from "moment";
import { allAccountsSelector } from "../../account";
import { contactsSelector } from "../../contact";
import { formatNumber } from "../../../common/formatNumber";

const formatInvoice = invoice => {
  const invoiceJSON = invoice.toJS();
  invoiceJSON.taxSummary =
    invoiceJSON.taxSummary &&
    invoiceJSON.taxSummary.map(tax => {
      tax.total = formatNumber(tax.total);
      return tax;
    });
  invoiceJSON.invoiceItems =
    invoiceJSON.invoiceItems &&
    invoiceJSON.invoiceItems.map(invoiceItem => {
      invoiceItem.total = formatNumber(invoiceItem.total);
      return invoiceItem;
    });
  invoiceJSON.subTotal = formatNumber(invoiceJSON.subTotal);
  invoiceJSON.total = formatNumber(invoiceJSON.total);
  if (invoiceJSON.archived) {
    invoiceJSON.status = "Archived";
  } else if (invoiceJSON.datePosted && invoiceJSON.dateEmailed) {
    invoiceJSON.status = "Sent";
  } else if (invoiceJSON.datePosted) {
    invoiceJSON.status = "Billed";
  } else {
    invoiceJSON.status = "Draft";
  }

  if (invoiceJSON.datePosted) {
    invoiceJSON.datePosted = moment(invoiceJSON.datePosted).format(
      "YYYY-MM-DD"
    );
  }
  if (invoiceJSON.dateEmailed) {
    invoiceJSON.dateEmailed = moment(invoiceJSON.dateEmailed).format(
      "YYYY-MM-DD"
    );
  }
  return fromJS(invoiceJSON);
};

export const invoicesSelector = (state: Map<string, any>) => {
  const invoices = state.getIn(["invoice", "invoices"]);
  if (!invoices.size) return fromJS([]);
  return invoices
    .filter(i => i !== undefined)
    .map(invoice => formatInvoice(invoice));
};
export const invoiceErrorSelector = (state: Map<string, any>) =>
  state.getIn(["invoice", "error"]);
export const invoicingResultsSelector = (state: Map<string, any>) =>
  state.getIn(["invoice", "invoicingResults"]);
export const invoicingResultsCountSelector = (state: Map<string, any>) =>
  state.getIn(["invoice", "invoicingResults"]).size;
export const selectedInvoiceSelector = (state: Map<string, any>) => {
  const selectedInvoiceId = state.getIn(["invoice", "selectedInvoiceId"]);
  const formattedInvoices = invoicesSelector(state);
  if (formattedInvoices.size) {
    const invoice = formattedInvoices.find(
      i => i.get("invoiceId") === selectedInvoiceId
    );
    return invoice;
  }
};
export const selectedInvoiceIdSelector = (state: Map<string, any>) =>
  state.getIn(["invoice", "selectedInvoiceId"]);
export const invoiceAccountSelector = (state: Map<string, any>) => {
  if (selectedInvoiceSelector(state)) {
    const billingAccountId = selectedInvoiceSelector(state).get(
      "billingAccountId"
    );
    const accounts = allAccountsSelector(state);
    return accounts && accounts.size
      ? accounts.find(
          account => account.get("billingAccountId") === billingAccountId
        )
      : fromJS({});
  }
};

export const invoiceAccountContactsSelector = (state: Map<string, any>) => {
  if (selectedInvoiceSelector(state)) {
    const billingAccountId = selectedInvoiceSelector(state).get(
      "billingAccountId"
    );
    const contacts = contactsSelector(state);
    return contacts && contacts.size && billingAccountId
      ? contacts.filter(
          contact => contact.get("billingAccountId") === billingAccountId
        )
      : fromJS([]);
  }
};

export const invoiceIsFetchingSelector = (state: Map<string, any>) =>
  state.getIn(["invoice", "isFetchingData"]);

export const selectedInvoiceIsPostedSelector = state => {
  const selectedInvoiceId = selectedInvoiceIdSelector(state);

  return (
    state
      .getIn(["invoice", "invoices"])
      .toJS()
      .some(
        ({ invoiceId, datePosted }) =>
          datePosted && invoiceId === selectedInvoiceId
      ) ||
    state
      .getIn(["invoice", "archive"])
      .toJS()
      .some(
        ({ invoiceId, datePosted }) =>
          datePosted && invoiceId === selectedInvoiceId
      )
  );
};

export const selectedInvoiceIsArchivedSelector = state => {
  const selectedInvoiceId = selectedInvoiceIdSelector(state);

  return (
    state
      .getIn(["invoice", "invoices"])
      .toJS()
      .some(
        ({ invoiceId, archived }) => archived && invoiceId === selectedInvoiceId
      ) ||
    state
      .getIn(["invoice", "archive"])
      .toJS()
      .some(
        ({ invoiceId, archived }) => archived && invoiceId === selectedInvoiceId
      )
  );
};

export const draftInvoicesSelector = state =>
  state.getIn(["invoice", "drafts"]).size
    ? state.getIn(["invoice", "drafts"]).map(invoice => formatInvoice(invoice))
    : fromJS([]);

export const archivedInvoicesSelector = state =>
  state.getIn(["invoice", "archive"]).size
    ? state.getIn(["invoice", "archive"]).map(invoice => formatInvoice(invoice))
    : fromJS([]);



// WEBPACK FOOTER //
// ./src/features/invoice/store/invoiceSelectors.js